function sleep(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }

// --- Subtotal flicker guard ---
window.__subtotalLockUntil = 0;

// --- Drawer hydration flag (first paint may lack items container) ---
window.__cartHydrated = !!document.querySelector(
  '#cart-drawer [data-cart-items], #cart-drawer #cart-items, #cart-drawer #cartItems, #cart-drawer .cart-items'
);

function stripCurrencyCode(txt) {
  // remove a trailing 3-letter code like “ USD” or “ USD.”
  return String(txt || '').replace(/\s?[A-Z]{3}\.?$/, '');
}

function setSubtotalTextFromServer(txt, { stripCode = true, lockMs = 1500 } = {}) {
  if (stripCode) txt = stripCurrencyCode(txt);
  setSubtotalText(txt);
  window.__subtotalLockUntil = Date.now() + lockMs; // block client formatter briefly
}

/* ================== Drawer opener available globally ================== */
function openCartDrawer() {
  const drawer  = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  if (!drawer || !overlay) return;

  // 1) Unhide
  drawer.classList.remove('hidden');
  overlay.classList.remove('hidden');

  // 2) PRE-STATE: ensure it's offscreen
  drawer.classList.remove('translate-x-0');
  drawer.classList.add('translate-x-full');

  // 3) Next frame: slide in
  requestAnimationFrame(() => {
    drawer.classList.remove('translate-x-full');
    drawer.classList.add('translate-x-0');
  });
}

function getCartSectionId() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return null;
  const wrapper = drawer.closest('[id^="shopify-section-"], .shopify-section');
  return wrapper?.dataset?.sectionId || (wrapper?.id || '').replace(/^shopify-section-/, '') || null;
}

/* ================== Drawer open/close ================== */
document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('.custom-cart-trigger');
  const drawer  = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const closeBtn= document.getElementById('cart-close');

  // Open via the custom trigger
  if (trigger) {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  }

  // Close helpers (guard each element)
  const closeDrawer = () => {
    if (!drawer || !overlay) return;
    drawer.classList.remove('translate-x-0');
    drawer.classList.add('translate-x-full');
    overlay.classList.add('hidden');
    setTimeout(() => drawer.classList.add('hidden'), 300);
  };

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);
});

/* ================== Quick-Add buttons (global, robust) ================== */

/** Small helper so we refresh more than once to avoid race/timing issues */
function refreshCartUISequence(delays = [0, 250, 900]) {
  delays.forEach(ms => {
    setTimeout(() => {
      Promise.resolve()
        .then(() => typeof fetchCartDrawerContents === 'function' && fetchCartDrawerContents())
        .then(() => typeof updateSubtotalFromCart   === 'function' && updateSubtotalFromCart())
        .then(() => document.dispatchEvent(new CustomEvent('cart:refresh')))
        .catch(console.error);
    }, ms);
  });
}

/** Visual busy state for the quick-add */
function setQuickAddBusy(btn, busy) {
  const host = btn.closest('product-quick-add') || btn;
  host?.setAttribute('aria-busy', busy ? 'true' : 'false');
  btn.disabled = !!busy;
  // swap icon/spinner if present
  const spinner = btn.querySelector('.icon--spinner');
  const plus    = btn.querySelector('.icon--plus');
  if (spinner) spinner.style.display = busy ? '' : 'none';
  if (plus)    plus.style.display    = busy ? 'none' : '';
}

/** Resolve variant id from a <product-quick-add> wrapper */
function getVariantIdFromQuickAdd(btn) {
  const host = btn.closest('product-quick-add');
  let id = host?.dataset?.id || host?.getAttribute('data-id');
  if (!id) {
    // fallback: look for hidden input[name="id"] nearby
    const input = host?.querySelector('input[name="id"]');
    if (input && input.value) id = input.value;
  }
  return id ? String(id).trim() : null;
}

/** Main handler: intercept any quick-add button anywhere */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.product-quick-add--button');
  if (!btn) return;

  // Prevent theme handler + possible link navigation
  e.preventDefault();
  e.stopImmediatePropagation(); // keep capture dominance for quick-add

  const variantId = getVariantIdFromQuickAdd(btn);
  if (!variantId) {
    // No variant? Just open the drawer (or fall back to PDP)
    openCartDrawer();
    return;
  }

  setQuickAddBusy(btn, true);

  // Do the AJAX add using helper (object payload is allowed)
  Promise.resolve()
    .then(() => addToCart({ id: Number(variantId), quantity: 1 }, { openDelayMs: 0 }))
    .then(() => {
      // Ensure UI is refreshed and then open the drawer (open happens in addToCart too)
      refreshCartUISequence([0, 250, 900]);
    })
    .catch(err => {
      console.error('Quick add failed:', err);
      // Optional: toast/alert here
    })
    .finally(() => setQuickAddBusy(btn, false));
}, true); // capture=true

/* ================== Cart count helper ================== */

function setCartCount(n) {
  const el = document.querySelector('.custom-cart-trigger');
  if (!el) return;
  const val = Math.max(0, parseInt(n || 0, 10)) || 0;
  el.setAttribute('data-cart-count', String(val));
}

function updateCartCountFromCart() {
  return fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(r => r.json())
    .then(cart => setCartCount(cart.item_count))
    .catch(console.error);
}


/* ================== Money + Subtotal helpers ================== */
function formatMoneyCents(cents) {
  try {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(
        cents,
        window.theme?.moneyFormat || window.Shopify.money_format || "${{amount}}"
      );
    }
  } catch (_) {}

  try {
    const currency = window.Shopify?.currency?.active || 'USD'; // fallback if not defined
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
    }).format((cents || 0) / 100);
  } catch (_) {
    return `${window.Shopify?.currency?.active || 'USD'} ${(cents || 0) / 100}`;
  }
}

function setSubtotalText(centsOrText) {
  const txt = (typeof centsOrText === 'number')
    ? formatMoneyCents(centsOrText)
    : String(centsOrText || '');
  document.querySelectorAll('#subtotal, #cart-drawer #subtotal, [data-subtotal]').forEach(el => {
    if ('value' in el) el.value = txt;
    else el.textContent = txt;
  });
}

function toggleEmptyState(cart) {
  const emptyEl = document.querySelector('.cart--empty');
  if (!emptyEl) return;
  if (cart.item_count === 0) emptyEl.classList.remove('hidden');
  else                       emptyEl.classList.add('hidden');
}

function updateSubtotalFromCart() {
  return fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(res => res.json())
    .then(cart => {
      const cents = typeof cart.items_subtotal_price === 'number'
        ? cart.items_subtotal_price
        : cart.total_price;
      const locked = Date.now() < (window.__subtotalLockUntil || 0);
      if (!locked) setSubtotalText(cents);
      toggleEmptyState(cart);
      setCartCount(cart.item_count);
    })
    .catch(err => console.error('Failed to update subtotal:', err));
}

/* Run twice to cover async theme transitions */
function refreshSubtotalSoon(delay = 250) {
  updateSubtotalFromCart();
  setTimeout(updateSubtotalFromCart, delay);
}

/* Broadcast hook */
function dispatchCartRefresh() {
  document.dispatchEvent(new CustomEvent('cart:refresh'));
}

/* ================== Add-to-cart helper (AJAX) ================== */
async function addToCart(payload, { openDelayMs = 200 } = {}) {
  const isForm = payload instanceof FormData;

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: isForm ? payload : JSON.stringify(payload),
    credentials: 'same-origin',
    cache: 'no-store'
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.description || 'Add to cart failed');
  }

  // Refresh the drawer content while it's still hidden (or before opening)
  if (typeof fetchCartDrawerContents === 'function') {
    try { await fetchCartDrawerContents(); } catch {}
  }
  if (typeof updateSubtotalFromCart === 'function') {
    try { await updateSubtotalFromCart(); } catch {}
  }

  // One-time buffer on first run to avoid opening before HTML swap completes
  await sleep(window.__cartHydrated ? openDelayMs : 180);

  openCartDrawer();
  dispatchCartRefresh();
}

/* ===== Helpers ===== */
function attachCartDrawerEvents() {
  const drawer  = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const closeBtn= document.getElementById('cart-close');
  if (!drawer || !overlay) return;

  const closeDrawer = () => {
    drawer.classList.remove('translate-x-0');
    drawer.classList.add('translate-x-full');
    overlay.classList.add('hidden');
    setTimeout(() => drawer.classList.add('hidden'), 300);
  };

  overlay.onclick = closeDrawer;
  if (closeBtn) closeBtn.onclick = closeDrawer;
}

function cartSectionCandidates() {
  const auto = getCartSectionId();
  const guesses = [
    'cart-drawer', 'mini-cart', 'cart-notification',
    'cart-sidebar', 'drawer-cart', 'cart-panel', 'cart'
  ];
  return Array.from(new Set([auto, ...guesses].filter(Boolean)));
}

/* ================== Add-to-cart (generic buttons with data-variant-id) ================== */
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.or-add,[data-add-to-cart]');
  if (!btn) return;

  const variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;

  e.preventDefault();
  // let theme bubble listeners run if present (we control AJAX add)

  const qtyAttr  = btn.getAttribute('data-quantity');
  const quantity = Math.max(1, parseInt(qtyAttr || '1', 10)) || 1;

  let properties = {};
  try {
    const props = btn.getAttribute('data-properties');
    if (props) properties = JSON.parse(props);
  } catch (_) {}

  const oldText = btn.textContent;
  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');
  btn.textContent = 'Adding…';

  const payload = { id: Number(variantId), quantity, ...(Object.keys(properties).length ? {properties} : {}) };

  try {
    await addToCart(payload, { openDelayMs: 0 });
    setTimeout(() => refreshCartUISequence?.([0, 250, 900]), 0);
  } catch (err) {
    console.error('Add to cart failed:', err);
    btn.textContent = 'Try again';
  } finally {
    btn.removeAttribute('aria-busy');
    setTimeout(() => { btn.disabled = false; btn.textContent = oldText; }, 1200);
  }
}, false); // bubble phase

/* ===== Drawer HTML refresh (multi-strategy, cache-busting) ===== */
/* --- DROP-IN: flicker-free cart drawer refresh --- */
let __cartRefreshInFlight = null;

async function fetchCartDrawerContents() {
  if (__cartRefreshInFlight) return __cartRefreshInFlight;

  __cartRefreshInFlight = (async () => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    // target may not exist on first load — create lazily if needed
    let target = drawer.querySelector('[data-cart-items], #cart-items, #cartItems, .cart-items');
    const hadTarget = !!target;

    // prevent jump while swapping
    let prevScroll = 0, prevH = 0;
    if (hadTarget) {
      prevScroll = target.scrollTop;
      prevH = target.offsetHeight;
      target.style.minHeight = prevH + 'px';
    }

    const candidates = cartSectionCandidates(); // best → common
    let html = '', parsed, usedKey = null;

    try {
      // 1) Try combined ?sections=<a,b,c> (JSON payload, fastest)
      if (candidates.length) {
        const url = `${(window.Shopify?.routes?.root ?? '/') }?sections=${encodeURIComponent(candidates.join(','))}&_=${Date.now()}`;
        const res = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (res.ok) {
          const json = await res.json().catch(() => ({}));
          for (const key of candidates) {
            if (json?.[key]) { html = json[key]; usedKey = key; break; }
          }
        }
      }

      // 2) Fallback: iterate ?section_id=<id> (raw HTML)
      if (!html) {
        for (const key of candidates) {
          const url2 = `${(window.Shopify?.routes?.root ?? '/') }?section_id=${encodeURIComponent(key)}&_=${Date.now()}`;
          const res2 = await fetch(url2, { credentials: 'same-origin', cache: 'no-store' });
          if (res2.ok) { html = await res2.text(); usedKey = key; if (html) break; }
        }
      }

      // 3) Last resort: try common cart views
      if (!html) {
        const views = ['drawer', 'mini-cart', 'ajax', 'side-drawer'];
        for (const v of views) {
          const res3 = await fetch(`/cart?view=${encodeURIComponent(v)}&_=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store' });
          if (res3.ok) { html = await res3.text(); usedKey = `view:${v}`; if (html) break; }
        }
      }

      if (!html) {
        await updateSubtotalFromCart().catch(() => {});
        if (hadTarget) target.style.minHeight = '';
        return;
      }

      parsed = document.createElement('div');
      parsed.innerHTML = html;

      // Prefer swapping just the items to avoid nuking decoded <img> nodes
      let incomingItems =
        parsed.querySelector('[data-cart-items], #cart-items, #cartItems, .cart-items') ||
        parsed.querySelector('#cart-drawer [data-cart-items], #cart-drawer #cart-items, #cart-drawer #cartItems, #cart-drawer .cart-items');

      // If no target yet but there are incoming items, create a container
      if (!target && incomingItems) {
        target = document.createElement('div');
        target.setAttribute('data-cart-items', '');
        drawer.appendChild(target);
      }

      if (incomingItems && target) {
        const newHTML = incomingItems.innerHTML.trim();

        // Skip swap if nothing changed
        if (target.dataset.lastHtml !== newHTML) {
          // Build a map of existing images by a stable key so we can reuse them
          const existingImgs = new Map();
          target.querySelectorAll('img').forEach(img => {
            const key =
              img.currentSrc || img.src ||
              img.getAttribute('data-src') ||
              img.getAttribute('data-srcset') ||
              img.getAttribute('srcset') || '';
            if (key) existingImgs.set(key, img);
          });

          // In the incoming markup, replace <img> with already-decoded nodes
          incomingItems.querySelectorAll('img').forEach(img => {
            const key =
              img.currentSrc || img.src ||
              img.getAttribute('data-src') ||
              img.getAttribute('data-srcset') ||
              img.getAttribute('srcset') || '';
            const keep = key && existingImgs.get(key);
            if (keep) img.replaceWith(keep);
          });

          // Move nodes instead of innerHTML (preserves reused <img>)
          target.replaceChildren(...Array.from(incomingItems.childNodes));
          target.dataset.lastHtml = newHTML;
        }
      } else {
        // As a last resort, replace the entire drawer (rare)
        const incomingDrawer = parsed.querySelector('#cart-drawer');
        if (incomingDrawer) {
          // Try to reuse images at drawer level too
          const existingImgs = new Map();
          drawer.querySelectorAll('img').forEach(img => {
            const key =
              img.currentSrc || img.src ||
              img.getAttribute('data-src') ||
              img.getAttribute('data-srcset') ||
              img.getAttribute('srcset') || '';
            if (key) existingImgs.set(key, img);
          });
          incomingDrawer.querySelectorAll('img').forEach(img => {
            const key =
              img.currentSrc || img.src ||
              img.getAttribute('data-src') ||
              img.getAttribute('data-srcset') ||
              img.getAttribute('srcset') || '';
            const keep = key && existingImgs.get(key);
            if (keep) img.replaceWith(keep);
          });

          drawer.replaceChildren(...Array.from(incomingDrawer.childNodes));
        } else {
          // If the response *is* the items list
          if (/data-cart-items|id=("cart-items"|"cartItems")|class="cart-items"/.test(html) && target) {
            target.innerHTML = html;
          }
        }
      }

      // --- also refresh the upsell block ---
      const incomingUpsell = parsed.querySelector('[data-upsell]');
      const currentUpsell  = drawer.querySelector('[data-upsell]');
      if (incomingUpsell && currentUpsell) {
        currentUpsell.outerHTML = incomingUpsell.outerHTML;
      }

      // Subtotal quick update (server text -> lock client formatter briefly)
      const incomingSubtotal = (parsed.querySelector('#subtotal,[data-subtotal]') || drawer.querySelector('#subtotal,[data-subtotal]'));
      if (incomingSubtotal) {
        const txt = (incomingSubtotal.value ?? incomingSubtotal.textContent ?? '').trim();
        if (txt) setSubtotalTextFromServer(txt, { stripCode: true, lockMs: 1500 });
      }

      // Finish up
      if (target) target.scrollTop = prevScroll;
      requestAnimationFrame(() => { if (hadTarget && target) target.style.minHeight = ''; });

      attachCartDrawerEvents(); // rebind close handlers after HTML swap
      document.dispatchEvent(new CustomEvent('cart:items-updated', { detail: { source: usedKey } }));
      window.__cartHydrated = true;
    } catch (err) {
      console.error('fetchCartDrawerContents error', err);
      if (hadTarget && target) target.style.minHeight = '';
    }
  })();

  try { return await __cartRefreshInFlight; }
  finally { __cartRefreshInFlight = null; }
}


/* ================== Universal cart network hooks ================== */
(function hookCartNetworkOnce(){
  if (window.__cartNetHooked) return;
  window.__cartNetHooked = true;

  const triggerRefresh = () => {
    try {
      // Multiple passes to beat race conditions in various themes
      refreshCartUISequence([0, 250, 900]);
    } catch (e) {
      // If your helper isn't available yet, at least do the essentials
      Promise.resolve()
        .then(() => typeof fetchCartDrawerContents === 'function' && fetchCartDrawerContents())
        .then(() => typeof updateSubtotalFromCart === 'function' && updateSubtotalFromCart())
        .then(() => document.dispatchEvent(new CustomEvent('cart:refresh')))
        .catch(console.error);
    }
  };

  const isCartEndpoint = (url = '') => /\/cart\/(?:add|change|update)\.js(?:\?|$)/.test(url);

  /* ---- fetch() patch ---- */
  const _fetch = window.fetch;
  if (_fetch) {
    window.fetch = async function patchedFetch(input, init) {
      const url    = (typeof input === 'string' ? input : input?.url) || '';
      const method = (init?.method || (typeof input !== 'string' && input?.method) || 'GET').toUpperCase();
      const res = await _fetch.apply(this, arguments);
      // On successful cart mutation, refresh subtotal & drawer contents
      if (isCartEndpoint(url) && method === 'POST' && res?.ok) {
        queueMicrotask(triggerRefresh);
      }
      return res;
    };
  }

  /* ---- XMLHttpRequest patch ---- */
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.__cartHook = { method: String(method || 'GET').toUpperCase(), url: String(url || '') };
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    if (!this.__hookedCartListener) {
      this.__hookedCartListener = true;
      this.addEventListener('loadend', () => {
        try {
          const { method, url } = this.__cartHook || {};
          if (isCartEndpoint(url) && method === 'POST' && this.status >= 200 && this.status < 400) {
            triggerRefresh();
          }
        } catch (e) { /* noop */ }
      });
    }
    return _send.apply(this, arguments);
  };

  // Safety: also react to common theme events if they exist
  ['added_to_cart', 'cart:updated', 'cart:change', 'ajaxProduct:added'].forEach(evt => {
    document.addEventListener(evt, triggerRefresh, { passive: true });
    window.addEventListener(evt, triggerRefresh, { passive: true });
  });
})();


/* ================== Add-to-cart (upsell) ================== */
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".add-upsell-to-cart");
  if (!btn) return;

  const variantId = btn.getAttribute("data-variant-id");
  if (!variantId) return;

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
    credentials: 'same-origin',
    cache: 'no-store'
  })
    .then(res => res.json())
    .then(() => {
      fetchCartDrawerContents().then(updateSubtotalFromCart);
      dispatchCartRefresh();
      openCartDrawer();
    })
    .catch(err => console.error("Failed to add upsell product:", err));
});

/* ================== Open cart on primary buy button ================== */
document.addEventListener('click', function (e) {
  const primary = e.target.closest('.product-buy-buttons--primary');
  if (!primary) return;

  // Open immediately
  openCartDrawer();

  // Then refresh items + subtotal after the theme's AJAX add finishes
  setTimeout(() => {
    fetchCartDrawerContents()?.then(updateSubtotalFromCart).then(dispatchCartRefresh);
  }, 250);
  setTimeout(() => {
    fetchCartDrawerContents()?.then(updateSubtotalFromCart).then(dispatchCartRefresh);
  }, 900);
});

/* ================== Single source of truth for cart changes ================== */
function findCartContextFrom(el) {
  const scope = el.closest('[data-cart-item], .cart-item, li[data-line], [data-variant-id], [data-line]') || el;

  let line = Number(
    el.getAttribute?.('data-line') ||
    el.dataset?.line ||
    scope?.getAttribute?.('data-line') ||
    scope?.dataset?.line ||
    0
  );

  let id =
    el.getAttribute?.('data-variant-id') ||
    el.dataset?.variantId ||
    scope?.getAttribute?.('data-variant-id') ||
    scope?.dataset?.variantId ||
    null;

  if (!id) {
    id =
      scope?.querySelector?.('input[name="id"]')?.value ||
      scope?.querySelector?.('[data-variant-id]')?.getAttribute('data-variant-id') ||
      null;
  }

  if (!line) {
    const lineHolder = scope?.querySelector?.('[data-line]');
    if (lineHolder) line = Number(lineHolder.getAttribute('data-line'));
  }

  return { line: Number.isFinite(line) && line > 0 ? line : 0, id };
}

function changeCartQuantity({ line, id, quantity }) {
  const payload = line ? { line, quantity } : (id ? { id, quantity } : null);
  if (!payload) return Promise.resolve();

  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
    credentials: 'same-origin',
    cache: 'no-store'
  })
    .then(() => fetchCartDrawerContents())
    .then(() => refreshSubtotalSoon(150))
    .then(dispatchCartRefresh)
    .catch(console.error);
}

/* ================== Remove buttons (general & selector) ================== */
document.addEventListener('click', function(e) {
  const removeBtn = e.target.closest('[data-cart-remove], .cart-remove, [data-remove], .quantity-selector--remove');
  if (!removeBtn) return;

  e.preventDefault();
  const { line, id } = findCartContextFrom(removeBtn);
  changeCartQuantity({ line, id, quantity: 0 });
});

/* ================== Plus / Minus ================== */
document.addEventListener('click', function(e) {
  const plus  = e.target.closest('.quantity-selector--plus');
  const minus = e.target.closest('.quantity-selector--minus');
  if (!plus && !minus) return;

  e.preventDefault();

  const container = (plus || minus).closest('.quantity-selector--container');
  if (!container) return;
  if (container.dataset.updating === '1') return;
  container.dataset.updating = '1';

  const input = container.querySelector('.quantity-selector--input, input[type="number"], [data-quantity-input], input[name="updates[]"], input[name^="updates"]');
  if (!input) { container.dataset.updating = ''; return; }

  const step = parseInt(input.getAttribute('step') || '1', 10) || 1;
  const min  = input.hasAttribute('min') ? parseInt(input.getAttribute('min'), 10) : 0;
  const max  = input.hasAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity;

  const current = parseInt(input.value, 10) || 0;
  let next = plus ? current + step : current - step;
  next = Math.max(min, Math.min(max, next));
  input.value = String(next);

  const ctx = findCartContextFrom(input);
  changeCartQuantity({ line: ctx.line, id: ctx.id, quantity: next })
    .finally(() => { container.dataset.updating = ''; });
});

/* ================== Typing / Blur on the input itself ================== */
const qtyDebounce = new WeakMap();
function debounceQty(el, fn, wait = 250) {
  const prev = qtyDebounce.get(el);
  if (prev) clearTimeout(prev);
  const t = setTimeout(fn, wait);
  qtyDebounce.set(el, t);
}

/* typing */
document.addEventListener('input', function(e) {
  const input = e.target.closest('.quantity-selector--input, input[type="number"][name^="updates"], [data-quantity-input]');
  if (!input) return;

  const container = input.closest('.quantity-selector--container');
  if (container?.dataset.updating === '1') return;

  let newQty = parseInt(input.value, 10);
  if (!Number.isFinite(newQty)) newQty = 0;
  if (newQty < 0) newQty = 0;

  const ctx = findCartContextFrom(input);
  debounceQty(input, () => {
    changeCartQuantity({ line: ctx.line, id: ctx.id, quantity: newQty });
  }, 300);
});

/* blur/change commit */
document.addEventListener('change', function(e) {
  const input = e.target.closest('.quantity-selector--input, input[type="number"][name^="updates"], [data-quantity-input]');
  if (!input) return;

  const container = input.closest('.quantity-selector--container');
  if (container?.dataset.updating === '1') return;

  let newQty = parseInt(input.value, 10);
  if (!Number.isFinite(newQty)) newQty = 0;
  if (newQty < 0) newQty = 0;

  const ctx = findCartContextFrom(input);
  changeCartQuantity({ line: ctx.line, id: ctx.id, quantity: newQty });
});

/* ================== Re-sync subtotal on global refresh ================== */
document.addEventListener('cart:refresh', updateSubtotalFromCart);

document.addEventListener('DOMContentLoaded', () => {
  updateSubtotalFromCart();  
});

/* ================== Hijax any PDP add-to-cart form ================== */
document.addEventListener('submit', function (e) {
  const form = e.target.closest('form[action*="/cart/add"]');
  if (!form) return;

  e.preventDefault();
  const fd = new FormData(form); // includes id, quantity, properties, selling_plan, etc.
  addToCart(fd);
});

/* Initial subtotal sync (idempotent) */
document.addEventListener('DOMContentLoaded', updateSubtotalFromCart);

/* Misc: close mobile nav by clicking overlay */
document.addEventListener("DOMContentLoaded", function () {
  const closeBtn = document.querySelector(".mobile-nav--close");
  const overlay  = document.querySelector(".drawer--overlay");

  if (closeBtn && overlay) {
    closeBtn.addEventListener("click", function () {
      overlay.click();
    });
  }
});

function attachAddToCartIndicators(selectors, addingText = "Adding…", resetText = "Add", delay = 2000) {
  selectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(btn => {
      btn.addEventListener("click", () => {
        const original = btn.innerText;
        btn.innerText = addingText;
        btn.disabled = true; // optional, prevents double clicks

        setTimeout(() => {
          btn.innerText = resetText || original;
          btn.disabled = false;
        }, delay);
      });
    });
  });
}

// Apply to both your buttons
attachAddToCartIndicators([
  ".add-upsell-to-cart",
  ".product-quick-add--button"
]);


//

if (!window.__shipAnim || !window.__shipAnim.__inited) {
  (function(){

(() => {
  const NS = '[ShipAnim]';
  const log = (...a)=>console.log(`%c${NS}`, 'color:#2563eb;font-weight:600', ...a);

  const CURRENCY = window.Shopify?.currency?.active || 'USD';
  const fmt = (cents) => {
    try { return new Intl.NumberFormat(undefined, {style:'currency', currency:CURRENCY}).format((cents||0)/100); }
    catch { return `${(cents||0)/100} ${CURRENCY}`; }
  };
  const pctStr = (n) => (Math.max(0, Math.min(100, n))).toFixed(1);
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  async function getCartTotal() {
    const r = await fetch('/cart.js', {cache:'no-store', credentials:'same-origin'});
    if (!r.ok) throw new Error('cart.js ' + r.status);
    const cart = await r.json();
    return cart.total_price || 0;
  }

  function readStartPct(container) {
    // Try the numeric-only class on the first inner div (e.g., "0.0"), else the bar's CSS var, else 0
    const header = container.querySelector(':scope > div');
    if (header) {
      const cls = (header.className || '').trim();
      if (/^\d+(?:\.\d+)?$/.test(cls)) return parseFloat(cls);
      const m = cls.match(/\b(\d+(?:\.\d+)?)\b/);
      if (m) return parseFloat(m[1]);
    }
    const bar = container.querySelector('.cart--shipping-bar');
    if (bar) {
      const v = (bar.style.getPropertyValue('--progress-percent') || getComputedStyle(bar).getPropertyValue('--progress-percent') || '').trim();
      const m = v.match(/([\d.]+)\s*%/);
      if (m) return parseFloat(m[1]);
    }
    return 0;
  }

  function applyFrame(container, pct, remainingCents, limitCents) {
    const bar = container.querySelector('.cart--shipping-bar');
    if (bar) bar.style.setProperty('--progress-percent', `${pctStr(pct)}%`);

    const header = container.querySelector(':scope > div');
    if (header) {
      // Replace numeric class token(s) with current percent
      const cls = header.className || '';
      if (/^\s*\d+(?:\.\d+)?\s*$/.test(cls)) header.className = pctStr(pct);
      else header.className = cls.replace(/\b\d+(?:\.\d+)?\b/g, pctStr(pct));
      header.setAttribute('data-progress', pctStr(pct));
      header.style.setProperty('--progress-percent', `${pctStr(pct)}%`);
    }

    const msg = container.querySelector('.cart--shipping-message');
    const check = container.querySelector('svg');
    if (msg) {
      if (remainingCents > 0) {
        msg.textContent = `Add ${fmt(remainingCents)} for free shipping`;
        if (check) check.classList.add('hide');
      } else {
        msg.textContent = `You got free shipping!`;
        if (check) check.classList.remove('hide');
      }
    }

    // Optional: expose values for debugging
    container.dataset.limitCents = limitCents;
    container.dataset.remainingCents = remainingCents;
  }

  function animate(container, fromPct, toPct, remainingCents, limitCents, dur=600) {
    const start = performance.now();
    function frame(now) {
      const t = Math.min(1, (now - start) / dur);
      const eased = fromPct + (toPct - fromPct) * easeOutCubic(t);
      applyFrame(container, eased, remainingCents, limitCents);
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  async function runOnce() {
    const containers = Array.from(document.querySelectorAll('.cart--shipping[data-limit-cents]'));
    if (!containers.length) return log('No .cart--shipping with data-limit-cents found.');

    const total = await getCartTotal();

    containers.forEach(container => {
      const limitCents = Math.max(1, parseInt(container.dataset.limitCents, 10) || 0);
      const toPct = Math.min(100, (total / limitCents) * 100);
      const remaining = Math.max(0, limitCents - total);
      const fromPct = readStartPct(container);
      animate(container, fromPct, toPct, remaining, limitCents, 600);
    });

    log('Animated threshold(s) from current to live % based on /cart.js');
  }

  // Expose a mini API
  window.__shipAnim = {
    refresh: runOnce
  };

  runOnce();

  // Re-animate on common cart events if they fire on your site
  ['cart:refresh','cart:items-updated','drawer:reloaded','added_to_cart','cart:updated']
    .forEach(evt => { window.addEventListener(evt, runOnce); document.addEventListener(evt, runOnce); });

})();

 window.__shipAnim.__inited = true;
  })();
}

if (!window.__cartQtyBound) {
  window.__cartQtyBound = true;

  /* ================== Plus / Minus ================== */
  document.addEventListener('click', function(e) {
    const plus  = e.target.closest('.quantity-selector--plus');
    const minus = e.target.closest('.quantity-selector--minus');
    if (!plus && !minus) return;

    // Prevent theme/app listeners from also handling the same click
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const container = (plus || minus).closest('.quantity-selector--container');
    if (!container) return;
    if (container.dataset.updating === '1') return;
    container.dataset.updating = '1';

    const input = container.querySelector(
      '.quantity-selector--input, input[type="number"], [data-quantity-input], input[name="updates[]"], input[name^="updates"]'
    );
    if (!input) { container.dataset.updating = ''; return; }

    // Prefer the DOM property .step; coerce to int; default 1
    const step = Math.max(1, parseInt(input.step || '1', 10) || 1);
    const min  = input.min !== '' ? parseInt(input.min, 10) : 0;
    const max  = input.max !== '' ? parseInt(input.max, 10) : Infinity;

    const current = parseInt(input.value, 10) || 0;
    let next = plus ? current + step : current - step;
    next = Math.max(min, Math.min(max, next));
    input.value = String(next);

    const ctx = findCartContextFrom(input);
    changeCartQuantity({ line: ctx.line, id: ctx.id, quantity: next })
      .finally(() => { container.dataset.updating = ''; });
  }, true); // capture to beat theme handlers

  /* ================== Typing ================== */
  document.addEventListener('input', function(e) {
    const input = e.target.closest('.quantity-selector--input, input[type="number"][name^="updates"], [data-quantity-input]');
    if (!input) return;
    const container = input.closest('.quantity-selector--container');
    if (container?.dataset.updating === '1') return;

    let newQty = parseInt(input.value, 10);
    if (!Number.isFinite(newQty) || newQty < 0) newQty = 0;

    const ctx = findCartContextFrom(input);
    debounceQty(input, () => {
      changeCartQuantity({ line: ctx.line, id: ctx.id, quantity: newQty });
    }, 300);
  }, true);

  /* ================== Blur/commit ================== */
  document.addEventListener('change', function(e) {
    const input = e.target.closest('.quantity-selector--input, input[type="number"][name^="updates"], [data-quantity-input]');
    if (!input) return;
    const container = input.closest('.quantity-selector--container');
    if (container?.dataset.updating === '1') return;

    let newQty = parseInt(input.value, 10);
    if (!Number.isFinite(newQty) || newQty < 0) newQty = 0;

    const ctx = findCartContextFrom(input);
    changeCartQuantity({ line: ctx.line, id: ctx.id, quantity: newQty });
  }, true);
}

(function openDrawerIfRedirectedFromCart() {
  function run() {
    let shouldOpen = false;

    try {
      shouldOpen = sessionStorage.getItem('OPEN_CART_DRAWER_ON_LOAD') === '1';
      if (shouldOpen) sessionStorage.removeItem('OPEN_CART_DRAWER_ON_LOAD');
    } catch (e) {}

    if (!shouldOpen) return;

    // ensure drawer exists before opening (themes can mount late)
    const tryOpen = (attempt = 0) => {
      const drawer = document.getElementById('cart-drawer');
      const overlay = document.getElementById('cart-overlay');

      if (drawer && overlay && typeof openCartDrawer === 'function') {
        // refresh first (optional but recommended)
        Promise.resolve()
          .then(() => typeof fetchCartDrawerContents === 'function' && fetchCartDrawerContents())
          .then(() => typeof updateSubtotalFromCart === 'function' && updateSubtotalFromCart())
          .catch(() => {})
          .finally(() => {
            openCartDrawer();
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          });
        return;
      }

      // retry a few times in case DOM mounts after scripts
      if (attempt < 30) setTimeout(() => tryOpen(attempt + 1), 50);
    };

    tryOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();


/* ================== s-atc fallback ================== */
document.addEventListener('click', (e) => {
  const s = e.target.closest('.s-atc');
  if (!s) return;
  // Give the theme a moment to finish its AJAX call, then refresh
  setTimeout(() => refreshCartUISequence([0, 250, 900]), 180);
}, true);



